import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface NotificationMessageProps {
  message: string;
}

const NotificationMessage: React.FC<NotificationMessageProps> = ({
  message,
}) => {
  return (
    <div className='flex py-3 px-4 items-start gap-2 self-stretch rounded-[10px] bg-light-blue-100'>
      <FontAwesomeIcon
        icon={faCircleInfo}
        className='text-reskin-primary-navy w-4 h-4 mt-0.5'
      />
      <div className='text-reskin-primary-dark text-sm font-inter-regular'>
        {message}
      </div>
    </div>
  );
};

export default NotificationMessage;
